/*
 * Module for the Participant Association Add View
*/
rs.module("participant/account/associations/add",

    ["common/select-helper"],

    function (selectHelper) {

        var _jsSelectors;
        var _cssClasses;
        var _backendUrls;
        var _codeValues;

        var _form;
        var _personNonPersonIndicators;

        var _dependentRelationshipSelected = false;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, codeValues, backendUrls, duplicatePersonLookup) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _codeValues = codeValues;
            _backendUrls = backendUrls;

            _form = $.js(_jsSelectors.form);
            _personNonPersonIndicators = _form.js(_jsSelectors.personNonPersonIndicators);

            // Register click event to person/non person indicators to toggle identification fields
            _personNonPersonIndicators.find("input").on("click", _togglePersonNonPerson);

            // Register click event to add role checkboxes to enable tab content
            _form.js(_jsSelectors.enableTabCheckbox, { multiple: true }).on("click", function () { _toggleTabContent($(this), true); });

            // Register change events for copy contact info checkboxes
            _form.js(_jsSelectors.copyAddressCheckbox).on("change", _copyAddressChanged);
            _form.js(_jsSelectors.copyEmailCheckbox).on("change", _copyEmailChanged);
            _form.js(_jsSelectors.copyPhoneCheckbox).on("change", _copyPhoneChanged);

            // Register click event for changing identity once an identity has previously been verified
            _form.js(_jsSelectors.changeIdentityLink).click(function () { _togglePageForIdentityVerified(false); });

            // Register demographic checkboxes' change events
            _form.js(_jsSelectors.disabilityCheckbox).change(_toggleDisability);
            _form.js(_jsSelectors.studentCheckbox).change(_toggleStudent);

            // Register click event for hiding/showing representative contact info
            _form.js(_jsSelectors.repCopyHomeCheckbox).find("input").change(function () {
                _form.js(_jsSelectors.repContactInfo).toggleClass(_cssClasses.visible, !$(this).is(":checked"));
            });

            // Register Spouse status/date change events
            _form.js(_jsSelectors.spouseStatusSelect).on("change", _defaultSpouseDates);
            _form.js(_jsSelectors.spouseEffectiveDate).on("change", _defaultSpouseDates);

            // default dependent relationship to bene relationship, unless dependent relationship has already been chosen by user
            _form.js(_jsSelectors.benRelationshipSelect).on("change", function () {
                if (!_dependentRelationshipSelected) {
                    selectHelper.getHelper(_form.js(_jsSelectors.depRelationshipSelect)).setValue($(this).val());
                }
            });

            // set flag to indicate dependent realtionship has been selected by the user
            _form.js(_jsSelectors.depRelationshipSelect).on("change", function () {
                _dependentRelationshipSelected = true;
            });

            // Tell duplicate person lookup where to pull lookup parameters from
            duplicatePersonLookup.onGetLookupParameters(function () {

                // Validate form before performing duplicate lookup
                var validator = _form.validate();
                var isValid = validator.form();

                // only send lookup parameters if form is valid
                if (isValid) {

                    var isPerson = _personNonPersonIndicators.find("input:checked").val() == "";

                    return {
                        isPerson: isPerson,
                        nonPersonType: isPerson ? null : _personNonPersonIndicators.find("input:checked").val(),
                        tin: isPerson ? _form.js(_jsSelectors.ssn).val().replace(/-/g, "").replace(/ /g, "") : _form.js(_jsSelectors.tin).val().replace(/-/g, "").replace(/ /g, ""),
                        firstName: isPerson ? _form.js(_jsSelectors.firstName).val().trim() : null,
                        lastName: isPerson ? _form.js(_jsSelectors.lastName).val().trim() : null,
                        nonPersonName: isPerson ? null : _form.js(_jsSelectors.nonPersonName).val().trim()
                    }
                }

                return null;
            });

            // Hookup callback function to be executed when duplicate selection is complete
            duplicatePersonLookup.onDuplicateSelectionComplete(_duplicateSelectionComplete);
        }

        //
        // Click event for person/nonperson indicators
        //
        function _togglePersonNonPerson() {
            var isPerson = this.value == 0;

            _form.js(_jsSelectors.personDemographics).toggleClass(_cssClasses.visible, isPerson);
            _form.js(_jsSelectors.nonPersonDemographics).toggleClass(_cssClasses.visible, !isPerson);
        }

        //
        // Callback to execute when duplicate selection is complete
        //
        function _duplicateSelectionComplete(participantKey) {

            // set hidden fields to be able to post values back on save since we will be disabling the identity fields
            _form.js(_jsSelectors.nonPersonTypeHidden).val(_personNonPersonIndicators.find("input:checked").val());
            _form.js(_jsSelectors.prefixHidden).val(_form.js(_jsSelectors.prefix).val().trim());
            _form.js(_jsSelectors.firstNameHidden).val(_form.js(_jsSelectors.firstName).val().trim());
            _form.js(_jsSelectors.middleNameHidden).val(_form.js(_jsSelectors.middleName).val().trim());
            _form.js(_jsSelectors.lastNameHidden).val(_form.js(_jsSelectors.lastName).val().trim());
            _form.js(_jsSelectors.suffixHidden).val(_form.js(_jsSelectors.suffix).val().trim());
            _form.js(_jsSelectors.ssnHidden).val(_form.js(_jsSelectors.ssn).val().trim());
            _form.js(_jsSelectors.nonPersonNameHidden).val(_form.js(_jsSelectors.nonPersonName).val().trim());
            _form.js(_jsSelectors.tinHidden).val(_form.js(_jsSelectors.tin).val().trim());

            if (participantKey == -1) {

                // If an existing participant was not selected, reset for a new person
                _resetFieldsForNoMatch();

                // move focus to next enabled input
                _form.find(`[data-js~=${_jsSelectors.demographics}] :tabbable:not(:disabled), [data-js~=${_jsSelectors.contactInfo}] :tabbable:not(:disabled), [data-js~=${_jsSelectors.roles}] :tabbable:not(:disabled)`).first().focus();
            }
            else {

                // If the selected duplicate is the member we are adding to, display an error and don't allow to proceed
                if (_form.js(_jsSelectors.ownerParticipantKey).val() == participantKey) {

                    _form.js(_jsSelectors.errorModal).modal('show');
                    _togglePageForIdentityVerified(false);
                    return;
                }

                // Is the duplicate a person
                var isPerson = _form.js(_jsSelectors.personNonPersonIndicators).find("input:checked").val() == "";

                // Retrieve existing person/nonperson info
                $.get(_backendUrls.loadExistingParticipantInfo,
                    {
                        participantKey: participantKey,
                        isPerson: isPerson

                    }).done(function (result) {

                        // clear demographics and contact info up front
                        _clearFields();

                        if (isPerson) {

                            _form.js(_jsSelectors.existingParticipantKey).val(result.person.personKey);

                            // populate identity inputs with the retrieved info for the duplicate person
                            _form.js(_jsSelectors.ssn).val(result.person.ssn);
                            _form.js(_jsSelectors.prefix).val(result.person.namePrefix);
                            _form.js(_jsSelectors.firstName).val(result.person.firstName);
                            _form.js(_jsSelectors.middleName).val(result.person.middleName);
                            _form.js(_jsSelectors.lastName).val(result.person.lastName);
                            _form.js(_jsSelectors.suffix).val(result.person.nameSuffix);

                            // copy values into hidden fields to be able to post values back on save since the identity fields are disabled
                            _form.js(_jsSelectors.ssnHidden).val(result.person.ssn);
                            _form.js(_jsSelectors.prefixHidden).val(result.person.namePrefix);
                            _form.js(_jsSelectors.firstNameHidden).val(result.person.firstName);
                            _form.js(_jsSelectors.middleNameHidden).val(result.person.middleName);
                            _form.js(_jsSelectors.lastNameHidden).val(result.person.lastName);
                            _form.js(_jsSelectors.suffixHidden).val(result.person.nameSuffix);

                            // populate demographic fields with retrieved info for the duplicate person
                            _form.js(_jsSelectors.birthDatePicker).val(result.person.birthDate ? new Date(result.person.birthDate).toISODateString() : null);
                            _form.js(_jsSelectors.birthCertFiledCheckbox).setChecked(result.person.birthCertifFiled);
                            _form.js(_jsSelectors.birthCityInput).val(result.person.birthPlace);
                            selectHelper.getHelper(_form.js(_jsSelectors.birthStateSelect)).setValue(result.person.birthState ? result.person.birthState.key : null);
                            _form.js(_jsSelectors.birthCountyInput).val(result.person.birthCounty);
                            selectHelper.getHelper(_form.js(_jsSelectors.genderSelect)).setValue(result.person.gender ? result.person.gender.key : null);
                            selectHelper.getHelper(_form.js(_jsSelectors.maritalStatusSelect)).setValue(result.person.maritalStatus ? result.person.maritalStatus.key : null);
                            _form.js(_jsSelectors.disabilityCheckbox).setChecked(result.person.disabled);
                            selectHelper.getHelper(_form.js(_jsSelectors.disabilityTypeSelect)).setValue(result.person.disabilityType ? result.person.disabilityType.key : null);
                            _form.js(_jsSelectors.disabilityDatePicker).val(result.person.disabledCertifFiledDate ? new Date(result.person.disabledCertifFiledDate).toISODateString() : null);
                            _form.js(_jsSelectors.studentCheckbox).setChecked(result.person.fullTimeStudent);
                            _form.js(_jsSelectors.studentDatePicker).val(result.person.fTStudentCertifFiledDate ? new Date(result.person.fTStudentCertifFiledDate).toISODateString() : null);
                        }
                        else {
                            _form.js(_jsSelectors.existingParticipantKey).val(result.nonPerson.nonPersonKey);

                            // populate identity inputs with the retrieved info for the duplicate nonperson
                            _form.js(_jsSelectors.nonPersonName).val(result.nonPerson.name);
                            _form.js(_jsSelectors.tin).val(result.nonPerson.tin);

                            // copy values into hidden fields to be able to post values back on save since the identity fields are disabled
                            _form.js(_jsSelectors.nonPersonNameHidden).val(result.nonPerson.name);
                            _form.js(_jsSelectors.tinHidden).val(result.nonPerson.tin);
                        }

                        // Does the participant have a home address on file?
                        if (result.homeAddress) {

                            _form.js(_jsSelectors.addressOnFileHidden).val(true);
                            _form.js(_jsSelectors.address1).val(result.homeAddress.address1);
                            _form.js(_jsSelectors.address2).val(result.homeAddress.address2);
                            _form.js(_jsSelectors.cityInput).val(result.homeAddress.city);
                            selectHelper.getHelper(_form.js(_jsSelectors.stateSelect)).setValue(result.homeAddress.state ? result.homeAddress.state.key : null);
                            _form.js(_jsSelectors.zipInput).val(result.homeAddress.zipCode.trim());
                            selectHelper.getHelper(_form.js(_jsSelectors.countrySelect)).setValue(result.homeAddress.country ? result.homeAddress.country.key : null);
                            _form.js(_jsSelectors.mailStopInput).val(result.homeAddress.mailStop);
                            _form.js(_jsSelectors.avasOverride).setChecked(result.homeAddress.avasOverrideFlag);

                            _persistAddressFields();
                        }
                        else {
                            _form.js(_jsSelectors.addressOnFileHidden).val(false);
                        }

                        // Does the participant have a home email on file?
                        if (result.homeEmail) {

                            _form.js(_jsSelectors.emailOnFileHidden).val(true);
                            _form.js(_jsSelectors.emailInput).val(result.homeEmail.emailAddress);

                            _persistEmailFields();
                        }
                        else {
                            _form.js(_jsSelectors.emailOnFileHidden).val(false);
                        }

                        // Does the participant have a home phone on file?
                        if (result.homePhone) {

                            _form.js(_jsSelectors.phoneOnFileHidden).val(true);
                            _form.js(_jsSelectors.countryCodeInput).val(result.homePhone.trimmedCountryCode);
                            _form.js(_jsSelectors.areaCodeInput).val(result.homePhone.trimmedAreacode);
                            _form.js(_jsSelectors.phoneNumberInput).val(result.homePhone.phoneNumber.trim());
                            _form.js(_jsSelectors.extensionInput).val(result.homePhone.trimmedExtension);

                            _persistPhoneFields();
                        }
                        else {
                            _form.js(_jsSelectors.phoneOnFileHidden).val(false);
                        }

                        // default representative fields
                        if (result.mainAddress || result.mainPhone || result.mainEmail) {
                            _form.js(_jsSelectors.repContactInfo).hide();
                            _form.js(_jsSelectors.repCopyHomeCheckbox).hide();
                            _form.js(_jsSelectors.repContactInfoMessage).show();
                            _form.js(_jsSelectors.repContactInfoOnFileHidden).val(true);
                        }
                        else {
                            _form.js(_jsSelectors.repContactInfo).show();
                            _form.js(_jsSelectors.repCopyHomeCheckbox).show();
                            _form.js(_jsSelectors.repContactInfoMessage).hide();
                            _form.js(_jsSelectors.repContactInfoOnFileHidden).val(false);
                        }

                        // Once all inputs are populated toggle sections/fields for identity verified
                        _togglePageForIdentityVerified(true);

                        // move focus to next enabled input
                        _form.find(`[data-js~=${_jsSelectors.demographics}] :tabbable:not(:disabled), [data-js~=${_jsSelectors.contactInfo}] :tabbable:not(:disabled), [data-js~=${_jsSelectors.roles}] :tabbable:not(:disabled)`).first().focus();
                    });
            }
        }

        //
        // Set up fields if there was no match selected
        //
        function _resetFieldsForNoMatch() {
            _clearFields();

            _form.js(_jsSelectors.existingParticipantKey).val("");

            // set address hidden field for no address on file
            _form.js(_jsSelectors.addressOnFileHidden).val(false);

            // set email hidden field for no email on file
            _form.js(_jsSelectors.emailOnFileHidden).val(false);

            // set phone hidden field for no phone on file
            _form.js(_jsSelectors.phoneOnFileHidden).val(false);

            _togglePageForIdentityVerified(true);
        }

        //
        // Populate the address inputs with the hidden field values containing the owner's address info
        //
        function _populateAddressFieldsWithOwner() {
            _form.js(_jsSelectors.address1).val(_form.js(_jsSelectors.ownerAddress1Hidden).val()).clearErrors();
            _form.js(_jsSelectors.address2).val(_form.js(_jsSelectors.ownerAddress2Hidden).val()).clearErrors();
            _form.js(_jsSelectors.cityInput).val(_form.js(_jsSelectors.ownerCityHidden).val()).clearErrors();
            selectHelper.getHelper(_form.js(_jsSelectors.stateSelect).clearErrors()).setValue(_form.js(_jsSelectors.ownerStateHidden).val());
            _form.js(_jsSelectors.zipInput).val(_form.js(_jsSelectors.ownerZipHidden).val()).clearErrors();
            selectHelper.getHelper(_form.js(_jsSelectors.countrySelect).clearErrors()).setValue(_form.js(_jsSelectors.ownerCountryHidden).val());
            _form.js(_jsSelectors.mailStopInput).val(_form.js(_jsSelectors.ownerMailStopHidden).val()).clearErrors();
            _form.js(_jsSelectors.avasOverride).setChecked(_form.js(_jsSelectors.ownerAvasOverridHidden).val() === 'True').clearErrors();
             
            _persistAddressFields();
        }

        //
        // Populate the phone inputs with the hidden field values containing the owner's phone info
        //
        function _populatePhoneFieldsWithOwner() {
            _form.js(_jsSelectors.countryCodeInput).val(_form.js(_jsSelectors.ownerCountryCodeHidden).val()).clearErrors();
            _form.js(_jsSelectors.areaCodeInput).val(_form.js(_jsSelectors.ownerAreaCodeHidden).val()).clearErrors();
            _form.js(_jsSelectors.phoneNumberInput).val(_form.js(_jsSelectors.ownerPhoneNumberHidden).val()).clearErrors();
            _form.js(_jsSelectors.extensionInput).val(_form.js(_jsSelectors.ownerExtensionHidden).val()).clearErrors();

            _persistPhoneFields();
        }

        //
        // Populate the email input with the hidden field value containing the owner's email
        //
        function _populateEmailFieldsWithOwner() {
            _form.js(_jsSelectors.emailInput).val(_form.js(_jsSelectors.ownerEmailHidden).val()).clearErrors();

            _persistEmailFields();
        }

        //
        // Enable/disable sections based on whether identity has been verified
        //
        function _togglePageForIdentityVerified(identityVerified) {
             
            _form.js(_jsSelectors.identityVerified).val(identityVerified);
            _form.js(_jsSelectors.saveButton).setDisabled(!identityVerified);

            _toggleIdentitySection(!identityVerified);
            _toggleContactInfoSection(identityVerified);
            _toggleDemographicsSection(identityVerified && _personNonPersonIndicators.find("input:checked").val() == "");
            _toggleRolesSection(identityVerified);

            _resetValidations();
        }

        //
        // Enable/disable the identity section
        //
        function _toggleIdentitySection(enable) {

            // enable/disable all non-hidden inputs in the section
            _form.js(_jsSelectors.identity).find("input").not("[type=hidden]").prop("disabled", !enable);

            // Have to use select helper to enable/disable any selects
            _form.js(_jsSelectors.identity).find("select").each(function () {
                selectHelper.getHelper($(this)).setDisabled(!enable);
            });

            _form.js(_jsSelectors.duplicatePersonLookup).toggle(enable);
            _form.js(_jsSelectors.changeIdentityLink).toggleClass(_cssClasses.visible, !enable);
        }

        //
        // Enable/disable the demographics section
        //
        function _toggleDemographicsSection(enable) {

            if (enable) {

                // enable/disable all non-hidden inputs in the section
                _form.js(_jsSelectors.demographics).find("input").not("[type=hidden]").prop("disabled", !enable);

                // Have to use select helper to disable any selects
                _form.js(_jsSelectors.demographics).find("select").each(function () {
                    selectHelper.getHelper($(this)).setDisabled(!enable);
                });

                // enable/disable disability fields based on checkbox
                var disabilityChecked = _form.js(_jsSelectors.disabilityCheckbox).is(":checked");
                selectHelper.getHelper(_form.js(_jsSelectors.disabilityTypeSelect)).setDisabled(!disabilityChecked);
                _form.js(_jsSelectors.disabilityDatePicker).prop("disabled", !disabilityChecked);

                // enable/disable student field based on checkbox
                var studentChecked = _form.js(_jsSelectors.studentCheckbox).is(":checked");
                _form.js(_jsSelectors.studentDatePicker).prop("disabled", !studentChecked);
            }
            else {
                _disableSectionFields(_jsSelectors.demographics);
            }
        }

        //
        // Enable/disable the contact info section
        //
        function _toggleContactInfoSection(enable) {

            if (enable) {

                var addressOnFile = JSON.parse(_form.js(_jsSelectors.addressOnFileHidden).val());
                var ownerAddressOnFile = _form.js(_jsSelectors.ownerAddress1Hidden).val() != "";

                _form.js(_jsSelectors.copyAddressCheckbox).prop("disabled", addressOnFile || !ownerAddressOnFile);
                _toggleAddressFields(!addressOnFile);

                var emailOnFile = JSON.parse(_form.js(_jsSelectors.emailOnFileHidden).val());
                var ownerEmailOnFile = _form.js(_jsSelectors.ownerEmailHidden).val() != "";

                _form.js(_jsSelectors.copyEmailCheckbox).prop("disabled", emailOnFile || !ownerEmailOnFile);
                _toggleEmailFields(!emailOnFile);

                var phoneOnFile = JSON.parse(_form.js(_jsSelectors.phoneOnFileHidden).val());
                var ownerPhoneOnFile = _form.js(_jsSelectors.ownerPhoneNumberHidden).val() != "";

                _form.js(_jsSelectors.copyPhoneCheckbox).prop("disabled", phoneOnFile || !ownerPhoneOnFile);
                _togglePhoneFields(!phoneOnFile);

            }
            else {

                _disableSectionFields(_jsSelectors.contactInfo);
            }
        }

        //
        // Enable/disable address fields
        //
        function _toggleAddressFields(enable) {

            var adressInputs = _form.js(_jsSelectors.addressInput, { multiple: true });

            // enable/disable inputs that aren't selects
            adressInputs.filter("input").prop("disabled", !enable).clearErrors();

            // Use selectHelper to handle any selects
            adressInputs.filter("select").each(function () {
                selectHelper.getHelper($(this).clearErrors()).setDisabled(!enable);
            });
        }

        //
        // Enable/disable email fields
        //
        function _toggleEmailFields(enable) {

            _form.js(_jsSelectors.emailInput).prop("disabled", !enable).clearErrors();
        }

        //
        // Enable/disable phone fields
        //
        function _togglePhoneFields(enable) {

            _form.js(_jsSelectors.phoneInput, { multiple: true }).prop("disabled", !enable).clearErrors();
        }

        //
        // Function to execute when the copy participant's address checkbox is changed
        //
        function _copyAddressChanged() {
            var copyOwnerAddress = $(this).is(":checked");

            if (copyOwnerAddress) {
                _populateAddressFieldsWithOwner();
            }
            else {
                _clearAddressFields();
            }
            
            _toggleAddressFields(!copyOwnerAddress);
        }

        //
        // Function to execute when the copy participant's email checkbox is changed
        //
        function _copyEmailChanged() {

            var copyOwnerEmail = $(this).is(":checked");

            if (copyOwnerEmail) {
                _populateEmailFieldsWithOwner();
            }
            else {
                _clearEmailFields();
            }

            _toggleEmailFields(!copyOwnerEmail);
        }

        //
        // Function to execute when the copy participant's phone checkbox is changed
        //
        function _copyPhoneChanged() {

            var copyOwnerPhone = $(this).is(":checked");

            if (copyOwnerPhone) {
                _populatePhoneFieldsWithOwner();
            }
            else {
                _clearPhoneFields();
            }

            _togglePhoneFields(!copyOwnerPhone);
        }

        //
        // Toggle disability fields based on disability checkbox
        //
        function _toggleDisability() {

            var checked = _form.js(_jsSelectors.disabilityCheckbox).is(":checked");
            var disabilityTypeHelper = selectHelper.getHelper(_form.js(_jsSelectors.disabilityTypeSelect));
            var disabilityDatePicker = _form.js(_jsSelectors.disabilityDatePicker);

            disabilityTypeHelper.setDisabled(!checked);
            disabilityDatePicker.prop("disabled", !checked);

            if (!checked) {
                disabilityTypeHelper.setValue("");
                disabilityDatePicker.val("");
            }
        }

        //
        // Toggle full time student fields based on full time student checkbox
        //
        function _toggleStudent() {

            var checked = _form.js(_jsSelectors.studentCheckbox).is(":checked");
            var studentDatePicker = _form.js(_jsSelectors.studentDatePicker);

            studentDatePicker.prop("disabled", !checked);

            if (!checked) {
                studentDatePicker.val("");
            }
        }

        //
        // Enable/disable the roles section
        //
        function _toggleRolesSection(enable) {

            var isPerson = _personNonPersonIndicators.find("input:checked").val() == "";

            _toggleTab(_jsSelectors.beneficiary, enable);
            _toggleTab(_jsSelectors.dependent, enable && isPerson);
            _toggleTab(_jsSelectors.dro, enable && isPerson);
            _toggleTab(_jsSelectors.spouse, enable && isPerson);
            _toggleTab(_jsSelectors.representative, enable);
        }

        //
        // Enable/disable a tab
        //
        function _toggleTab(tabSelector, enable) {

            // Get the Add Role checkbox from the tab content
            var addRoleCheckbox = _form.js("_content", { multiple: true }).filter(`[data-tab=${tabSelector}]`).js(_jsSelectors.enableTabCheckbox);

            // Need to toggle add role checkbox separately because, by design, _toggleTabContent() excludes it
            addRoleCheckbox.prop("disabled", !enable);

            // Toggle tab content based on the state of the add role checkbox
            _toggleTabContent(addRoleCheckbox, false);
        }

        //
        // Enable/disable fields for a tab based on whether its add role checkbox is checked
        //
        function _toggleTabContent(checkbox, clear) {

            var enable = !checkbox.is(":disabled") && checkbox.is(":checked");
            var tabContent = checkbox.closest("[data-js=_content]");
            var tab = _form.js("_tab", { multiple: true }).filter(`[data-tab=${tabContent.data("tab")}]`);

            if (!checkbox.is(":disabled")) {
                // append/remove an asterisk on the tab name to indicate if a role is being added or not
                var tabText = tab.html().replace("*", "");
                tab.html(enable ? `${tabText}*` : tabText);
            }

            // enable/disable all inputs in the tab except the add role checkbox
            var inputs = tabContent.find("input").not(checkbox).not("[type=hidden]").prop("disabled", !enable).clearErrors();

            // if we are disabling and clearing, set all input values to null
            if (!enable && clear) {
                inputs.val(null);
            }

            // have to use select helper to disable any selects
            tabContent.find("select").each(function () {
                var helper = selectHelper.getHelper($(this).clearErrors()).setDisabled(!enable);

                // if we are disabling and clearing, set all select values to null
                if (!enable && clear) {
                    helper.setValue(null);
                }
            });

            // the tab has been fully reset, so reapply default values to it's fields
            _reapplyTabDefaultValues(tabContent, enable);
            
            _resetValidations();
        }

        //
        // Helper method to reapply default values to a tab's fields as it is enabled/disabled
        //
        function _reapplyTabDefaultValues(tabContent, enable) {

            // get container of all tabs content so we can access fields in different tabs
            var tabsContainer = $.js(_jsSelectors.roles);

            // If the tab is being disabled, reapply default values to the appropriate tab's fields
            if (!enable) {

                // beneficiary tab is visible
                var benStatusSelect = tabContent.js(_jsSelectors.benStatusSelect, { required: false });
                if (benStatusSelect.length > 0) {

                    // default status to nominated
                    selectHelper.getHelper(benStatusSelect).setValue(_codeValues.nominatedBeneficary);  

                    // clear dependent relationship if not specifically selected, whose default is from the beneficiary relationship
                    if (!_dependentRelationshipSelected) {
                        tabsContainer.js(_jsSelectors.depRelationshipSelect).val();
                        selectHelper.getHelper(tabsContainer.js(_jsSelectors.depRelationshipSelect)).setValue(null);
                    }
                }

                // dependent tab is visible
                var depStatusSelect = tabContent.js(_jsSelectors.depStatusSelect, { required: false });
                if (depStatusSelect.length > 0) {

                    // default status to active
                    selectHelper.getHelper(depStatusSelect).setValue(_codeValues.activeDependent);

                    // default relationship to currently selected beneficiary relationship
                    var selectedBeneficiaryRelationship = tabsContainer.js(_jsSelectors.benRelationshipSelect).val();
                    selectHelper.getHelper(tabContent.js(_jsSelectors.depRelationshipSelect)).setValue(selectedBeneficiaryRelationship);
                    _dependentRelationshipSelected = false;
                }

                // dro tab is visible (default status to nominated)
                var droStatusSelect = tabContent.js(_jsSelectors.droStatusSelect, { required: false });
                if (droStatusSelect.length > 0) {
                    selectHelper.getHelper(droStatusSelect).setValue(_codeValues.nominatedDro);
                }

                // spouse tab is visible (default status to active)
                var spouseStatusSelect = tabContent.js(_jsSelectors.spouseStatusSelect, { required: false });
                if (spouseStatusSelect.length > 0) {
                    selectHelper.getHelper(spouseStatusSelect).setValue(_codeValues.activeSpouse);
                }

                // representative tab (default status to active)
                var repStatusSelect = tabContent.js(_jsSelectors.repStatusSelect, { required: false });
                if (repStatusSelect.length > 0) {
                    selectHelper.getHelper(repStatusSelect).setValue(_codeValues.activeContact);
                }
            }
        }

        //
        // Helper method to disable all fields in a section
        //
        function _disableSectionFields(sectionSelector) {

            // disable all non-hidden inputs in the section
            _form.js(sectionSelector).find("input").not("[type=hidden]").prop("disabled", true).clearErrors();

            // Have to use select helper to disable any selects
            _form.js(sectionSelector).find("select").each(function () {
                $(this).clearErrors();
                selectHelper.getHelper($(this)).setDisabled(true);
            });
        }

        //
        // Copy address inputs to hidden fields in order to persist them
        //
        function _persistAddressFields() {
            _form.js(_jsSelectors.address1Hidden).val(_form.js(_jsSelectors.address1).val());
            _form.js(_jsSelectors.address2Hidden).val(_form.js(_jsSelectors.address2).val());
            _form.js(_jsSelectors.cityHidden).val(_form.js(_jsSelectors.cityInput).val());
            _form.js(_jsSelectors.stateHidden).val(_form.js(_jsSelectors.stateSelect).val());
            _form.js(_jsSelectors.zipHidden).val(_form.js(_jsSelectors.zipInput).val());
            _form.js(_jsSelectors.countryHidden).val(_form.js(_jsSelectors.countrySelect).val());
            _form.js(_jsSelectors.mailStopHidden).val(_form.js(_jsSelectors.mailStopInput).val());
            _form.js(_jsSelectors.avasOverrideHidden).val(_form.js(_jsSelectors.avasOverride).prop("checked"));
        }

        //
        // Copy phone inputs to hidden fields in order to persist them
        //
        function _persistPhoneFields() {
            _form.js(_jsSelectors.countryCodeHidden).val(_form.js(_jsSelectors.countryCodeInput).val());
            _form.js(_jsSelectors.areaCodeHidden).val(_form.js(_jsSelectors.areaCodeInput).val());
            _form.js(_jsSelectors.phoneNumberHidden).val(_form.js(_jsSelectors.phoneNumberInput).val());
            _form.js(_jsSelectors.extensionHidden).val(_form.js(_jsSelectors.extensionInput).val());
        }

        //
        // Copy email inputs to hidden fields in order to persist them
        //
        function _persistEmailFields() {
            _form.js(_jsSelectors.emailHidden).val(_form.js(_jsSelectors.emailInput).val());
        }

        //
        // Clear all demographics and contact info inputs (used when changing the association's identity)
        //
        function _clearFields() {

            _clearAddressFields();
            _clearPhoneFields();
            _clearEmailFields();

            // clear demographic fields
            _form.js(_jsSelectors.birthDatePicker).val(null);
            _form.js(_jsSelectors.birthCertFiledCheckbox).setChecked(false);
            _form.js(_jsSelectors.birthCityInput).val(null);
            selectHelper.getHelper(_form.js(_jsSelectors.birthStateSelect)).setValue(null);
            _form.js(_jsSelectors.birthCountyInput).val(null);
            selectHelper.getHelper(_form.js(_jsSelectors.genderSelect)).setValue(null);
            selectHelper.getHelper(_form.js(_jsSelectors.maritalStatusSelect)).setValue(null);
            _form.js(_jsSelectors.disabilityCheckbox).setChecked(false);
            selectHelper.getHelper(_form.js(_jsSelectors.disabilityTypeSelect)).setValue(null);
            _form.js(_jsSelectors.disabilityDatePicker).val(null);
            _form.js(_jsSelectors.studentCheckbox).setChecked(false);
            _form.js(_jsSelectors.studentDatePicker).val(null);
        }

        //
        // Clear all address fields
        //
        function _clearAddressFields() {

            // clear address inputs 
            _form.js(_jsSelectors.address1).val(null);
            _form.js(_jsSelectors.address2).val(null);
            _form.js(_jsSelectors.cityInput).val(null);
            selectHelper.getHelper(_form.js(_jsSelectors.stateSelect)).setValue(null);
            _form.js(_jsSelectors.zipInput).val(null);
            selectHelper.getHelper(_form.js(_jsSelectors.countrySelect)).setValue(_codeValues.usa);
            _form.js(_jsSelectors.mailStopInput).val(null);
            _form.js(_jsSelectors.avasOverride).setChecked(false);

            // clear address hidden inputs 
            _form.js(_jsSelectors.address1Hidden).val(null);
            _form.js(_jsSelectors.address2Hidden).val(null);
            _form.js(_jsSelectors.cityHidden).val(null);
            _form.js(_jsSelectors.stateHidden).val(null);
            _form.js(_jsSelectors.zipHidden).val(null);
            _form.js(_jsSelectors.countryHidden).val(null);
            _form.js(_jsSelectors.mailStopHidden).val(null);
            _form.js(_jsSelectors.avasOverrideHidden).val(false);
        }

        //
        // Clear all phone fields
        //
        function _clearPhoneFields() {

            // clear phone inputs 
            _form.js(_jsSelectors.countryCodeInput).val("1");
            _form.js(_jsSelectors.areaCodeInput).val(null);
            _form.js(_jsSelectors.phoneNumberInput).val(null);
            _form.js(_jsSelectors.extensionInput).val(null);

            // clear phone hidden inputs 
            _form.js(_jsSelectors.countryCodeHidden).val(null);
            _form.js(_jsSelectors.areaCodeHidden).val(null);
            _form.js(_jsSelectors.phoneNumberHidden).val(null);
            _form.js(_jsSelectors.extensionHidden).val(null);
        }

        //
        // Clear all email fields
        //
        function _clearEmailFields() {

            // clear email inputs/hidden 
            _form.js(_jsSelectors.emailHidden).val(null);
            _form.js(_jsSelectors.emailInput).val(null);
        }

        //
        // Default spouse dates based on status
        //
        function _defaultSpouseDates() {
            var status = _form.js(_jsSelectors.spouseStatusSelect).val();

            if (status == _codeValues.activeSpouse) {
                _form.js(_jsSelectors.marriageDate).val(_form.js(_jsSelectors.spouseEffectiveDate).val());
                _form.js(_jsSelectors.divorceDate).val(null);
            }
            else if (status == _codeValues.inactiveSpouse) {
                _form.js(_jsSelectors.divorceDate).val(_form.js(_jsSelectors.spouseEffectiveDate).val());
            }
        }

        ///
        /// Resets unobtrusive validations, which is required after enabling previously disabled fields.
        ///
        function _resetValidations() {
            $.validator.resetValidation(_form);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);